<div class="text-content" [innerHtml]="htmlToShow()"></div>
